/** Pantallas donde Breaky flotante estorba: acceso, legal y juegos. En Ayuda (chat y FAQ) sí se ve. */
const HIDDEN_PREFIXES = ['/auth', '/legal', '/dashboard/juegos'];

/** ¿Se esconde Breaky flotante en esta ruta? */
export function isCompanionHidden(url: string): boolean {
  const path = url || '';
  return HIDDEN_PREFIXES.some((p) => path.startsWith(p));
}
